import { getHeaders, getDomainOrigin } from 'utils/serverConfig';
import { dealerUrls } from 'utils/api/urls';
import axios from 'axios';

export const getDealerDashboard = async (
    page: number,
    tab?: string,
    journey?: string
) => {
    try {
        const { status, data } = await axios({
            method: 'GET',
            url: `${getDomainOrigin()}/${dealerUrls.dashboardDashboard}`,
            params: {
                page,
                status: tab,
                journey,
            },
            headers: getHeaders(),
        });
        if (status === 200 && data) {
            return {
                data,
                status: true,
            };
        }
        return {
            status: false,
        };
    } catch (e: any) {
        if (e?.response?.status === 401) {
            window.location.href = '/login';
        }
        return {
            status: false,
        };
    }
};
